const TOOLTIP_GAP = 12;
const VIEWPORT_MARGIN = 8;

interface TooltipSize {
  contentSize: number[];
  viewSize: number[];
}

/** Keep ECharts HTML tooltips inside the viewport, flipping left near the right edge. */
export function positionChartTooltip(point: number[], size: TooltipSize): [number, number] {
  const [pointerX, pointerY] = point;
  const [contentWidth, contentHeight] = size.contentSize;
  const [viewWidth, viewHeight] = size.viewSize;
  const preferredLeft =
    pointerX + TOOLTIP_GAP + contentWidth > viewWidth
      ? pointerX - TOOLTIP_GAP - contentWidth
      : pointerX + TOOLTIP_GAP;

  return [
    Math.max(VIEWPORT_MARGIN, Math.min(preferredLeft, viewWidth - contentWidth - VIEWPORT_MARGIN)),
    Math.max(
      VIEWPORT_MARGIN,
      Math.min(pointerY + TOOLTIP_GAP, viewHeight - contentHeight - VIEWPORT_MARGIN),
    ),
  ];
}
